module.exports = __webpack_public_path__ + "img/game-bar.fd76831.png";